import React, { useMemo } from "react";
import Select from "react-select";
import { useFormikContext, ErrorMessage } from "formik";
import { useGetAreasQuery } from "../services/redux/api/components";

const AreaDropdown = ({
  name = "AreaID",
  pageNumber = 1,
  pageSize = 200,
  value,
  onChange,
}) => {
  const { data: areas, isLoading, isFetching, error } = useGetAreasQuery({
    pageNumber,
    pageSize,
  });

  const { setFieldValue, values } = useFormikContext();

  // ✅ Prepare area data for react-select
  const options = useMemo(() => {
    if (!areas?.data || !Array.isArray(areas.data)) return [];
    return areas.data.map((item) => ({
      ...item,
      value: item.AreaID ?? item.id ?? item.AreaId ?? item.areaId,
      label:
        item.Area ??
        item.AreaName ??
        item.Name ??
        item.DisplayName ??
        `#${item.AreaID ?? ""}`,
    }));
  }, [areas]);

  const selectedValue =
    options.find(
      (opt) =>
        String(opt.value) ===
        String(value ?? values?.[name] ?? "")
    ) || null;

  const handleChange = (selectedOption) => {
    const newValue = selectedOption ? selectedOption.value : "";
    if (onChange) onChange({ target: { name, value: newValue } });
    setFieldValue(name, newValue);
  };

  return (
    <div className="px-2">
      <label className="form-label">Area</label>

      <Select
        name={name}
        options={options}
        value={selectedValue}
        onChange={handleChange}
        isSearchable
        isClearable
        isLoading={isLoading || isFetching}
        placeholder={
          isLoading || isFetching ? "Loading areas..." : "Select"
        }
        styles={{
          control: (base, state) => ({
            ...base,
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
            border: state.isFocused
              ? "1px solid #EB2B21"
              : "1px solid #D1D5DB",
            borderRadius: "10px",
            padding: "2px 2px",
            fontSize: "14px",
            outline: "none",
            "&:hover": {
              borderColor: state.isFocused ? "#EB2B21" : "#9ca3af",
            },
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            borderRadius: "10px",
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.15)",
          }),
        }}
      />

      {error && (
        <div className="text-red-600 text-sm mt-1">
          Error loading areas
        </div>
      )}
      <ErrorMessage
        name={name}
        component="div"
        className="text-red-600 text-sm mt-1"
      />
    </div>
  );
};

export default AreaDropdown;
